import React from 'react';
import ReactDOM from 'react-dom/client';
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { SubdomainProvider } from './context/SubdomainContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <SubdomainProvider>
      <DndProvider backend={HTML5Backend}>
        <App />
      </DndProvider>
    </SubdomainProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
